(ns ycweb.app.admin.common
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.admin.stores.overview]
   [ycweb.components.headings :as headings]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]))

;; Stat blocks that display data and can handle clicks
(rum/defc stats-block < rum/static
  [{:keys [title qty breakdown url color-class warning? text-pill] :as data}]
  [:div
   {:class (u/bem :flex-grid-block [:xxl-1-5 :xl-1-4 :l-1-3 :ml-1-2])}
   [:article.flex-grid-content
    [(if url :a :div)
     (u/maybe assoc
     {:class
      (concat
        (case color-class
          :yellow [:u-bg-casablanca]
          :blue [:u-bg-greenery :u-text-white]
          (when-not warning? [:u-bg-mist]))
        (u/bem
          :admin-stats-card
          [(when breakdown :has-overlay)
           (when warning? :has-warning)]))}
           :href (when (u/presence url) url)
           :target (when (u/presence url) "_blank"))

     [:header.admin-stats-card__header
      [:h1.admin-stats-card__title title]
      [:p.admin-stats-card__value qty]]

     (when url
       [:i.admin-stats-card__icon {:class (u/bem :icon [:is-dark :arrow-right :block])}])

     (when breakdown
       [:div.admin-stats-card__overlay
        (into
          [:ul.admin-stats-card-details]
          (for [detail breakdown]
            [:li.admin-stats-card-details__item (:title detail) ": " (:qty detail)]))])

     (when text-pill
       [:p.admin-stats-card__time text-pill])]]])

(rum/defc action-link < rum/static
  [{:keys [title href href-props sub-list target-blank? :as options]}]
  [:li.admin-action-item
   (if (or href-props href)
     [:a.admin-action-item__text
      (if href-props
        (merge
          href-props
          {:target (when target-blank? "_blank")})
        {:href href
         :target (when target-blank? "_blank")})
      [:span.admin-action-item__icon
       [:i {:class (u/bem :icon [:label])}]]
      [:span.admin-action-item__title title]]
     [:b.u-block.u-margin-top-12.u-margin-bottom-12
      [:i {:class (u/bem :icon [:document :inline :in-copy-left])}]
       title])
   (when sub-list
     (into
       [:ul.admin-action-item__sublist]
       (map
         (fn [sub-list-item]
           [:li
            [:a.admin-action-item__sublist-link
             (or (:href-props sub-list-item) {:href (:href sub-list-item)})
             (:title sub-list-item)]]) sub-list)))])

(rum/defc action-link-list < rum/static
  [{:keys [list-title list-items sub-list]}]
  [:<>
   [:h2.admin-action-list__section-title list-title]
   (into
     [:ul.admin-action-list]
     (map
       action-link
       list-items))])

(rum/defc action-link-list-collapse < rum/reactive
  [app-atom {:keys [list-title list-items stat-count stat-style] :as options}]
  (let [open? (cmn/curact app-atom [:link-list-open? (keyword (str/lower-case list-title))])]
    (when (and list-title list-items)
      [:<>
       [:header.admin-action-list__section-title.u-block-link
        {:on-click
         (fn []
           (swap! app-atom assoc-in [:link-list-open? (keyword (str/lower-case list-title))]
             (not open?)))}

        [:div
         {:class (u/bem :flex-grid-group [:align-left :valign-middle])}
         [:div
          {:class (u/bem :flex-grid-block [:fluid])}
          [:div.flex-grid-content
           (headings/heading list-title {:type :h2 :size :small :flush true})]]

         (when stat-count
           [:div
            {:class (u/bem :flex-grid-block [:fluid :align-left])}
            [:div.flex-grid-content
             {:style {:margin-top "-4px"}}
             [:span
              {:class (u/bem :text-pill [:medium :inline (or stat-style :dark)])}
              (str "(" stat-count ")")]]])

         [:div
          {:class (u/bem :flex-grid-block [:fluid :align-right])}
          [:div.flex-grid-content
           [:i {:class (u/bem :icon [(if open? :minus :plus) :block :is-dark])}]]]]]

       (when open?
         (into
           [:ul.admin-action-list]
           (map
             action-link
             list-items)))])))